import type { SvgIconComponent } from '@mui/icons-material';
import type { SvgIconProps, SxProps } from '@mui/material';
import { type CSSProperties, forwardRef } from 'react';

export type IconProps = {
  icon: SvgIconComponent;
  size?: 'xSmall' | 'small' | 'medium' | 'large' | string;
  sx?: SxProps;
} & Omit<SvgIconProps, 'sx'>;

/**
 * Forwards ref and extra props to the underlying `SvgIcon` so wrappers such as
 * `Tooltip` can attach to it directly.
 */
export const Icon = forwardRef<SVGSVGElement, IconProps>(
  ({ icon, size = 'medium', sx, ...rest }, ref) => {
    const NewIcon = icon;
    const style: CSSProperties = {};

    switch (size) {
      case 'xSmall':
        style.width = '12px';
        style.height = '12px';
        break;
      case 'small':
        style.width = '16px';
        style.height = '16px';
        break;
      case 'medium':
        style.width = '24px';
        style.height = '24px';
        break;
      case 'large':
        style.width = '32px';
        style.height = '32px';
        break;
      default:
        style.width = size;
        style.height = size;
        break;
    }

    return <NewIcon {...rest} ref={ref} style={style} sx={sx} />;
  },
);
